import { CircularProgress } from '@ouster/webviz-react-components';

import { useEffect, useState } from 'react';
import { MdOutline3dRotation } from 'react-icons/md';
import { RxArrowRight } from 'react-icons/rx';
import { Link, useNavigate } from 'react-router-dom';

import { useKeycloak } from '../../KeycloakContext';
import { useStoreState, useStoreActions } from '../../reducers';
// import { LOGIN_APPROACHES } from '../../utils/constants';
import styles from '../PublicPage.module.css';

/* 
  When user lands on the landing page, the app check whether there is 'idp_hint' in local storage.
    Yes - try to auto login user based on the idp_hint
      if the login doesn't work, user will stay on login page.
      if keycloak authentication pass, the app will check whether the user is existed in db
        if yes, user will be sent to drive list page.
        if no, user will stay on landing page.
    No - stay on page, no auto login happen
*/

// const idpHint = localStorage.getItem('idp_hint');

export default function LandingPage() {
  const { keycloak } = useKeycloak();
  const navigate = useNavigate();
  const { user, appUser } = useStoreState((storeState) => ({
    ...storeState.user,
  }));
  const { fetchUserRoleByIdentity } = useStoreActions(
    (actions) => actions.user
  );

  // below code is commented out since we remove our login logic to keycloak
  // just save it here for shot term in case we need to revert to original flow
  // it should be cleaned up after kc flow is launched

  // const [isFetchingUser, setIsFetchingUser] = useState(true);
  /*
    Auto login user with keycloak if applicable
  */
  // useEffect(() => {
  //   /*
  //     When we can't find user's preferred  login approach
  //     we will not try to auto login user
  //   */
  //   if (!idpHint) {
  //     setIsFetchingUser(false);
  //     return;
  //   }

  //   // Login keycloak using its default method - sso (saml)
  //   const loginToKeycloak = async () => {
  //     await keycloak?.login();
  //     if (!keycloak?.authenticated) {
  //       setIsFetchingUser(false);
  //     }
  //   };

  //   if (keycloak && !keycloak.authenticated) {
  //     if (idpHint === LOGIN_APPROACHES.SSO) {
  //       loginToKeycloak();
  //     } else if (idpHint === LOGIN_APPROACHES.GOOGLE) {
  //       const url = keycloak.createLoginUrl({ idpHint: 'google' });
  //       window.location.href = url;
  //     } else {
  //       setIsFetchingUser(false);
  //     }
  //   }
  // }, [keycloak]);

  /*
    If user has been authenticated with keycloak,
    we will authorize the user with studio
  */
  // useEffect(() => {
  //   const authorizeUser = async () => {
  //     if (user?.identity_id) {
  //       setIsFetchingUser(true);
  //       try {
  //         console.log('6666');
  //         await fetchUserRoleByIdentity(user.identity_id);
  //         navigate('/drive', { replace: true });
  //       } catch (error) {
  //         /*
  //           User exist in keycloak but not in studio. Send user to sign up page and go through country and eula flow.
  //           */
  //         console.log('7777');
  //         navigate('/sign_up', { replace: true });
  //       }
  //     }
  //   };

  //   authorizeUser();
  // }, [
  //   fetchUserRoleByIdentity,
  //   isFetchingUser,
  //   keycloak,
  //   navigate,
  //   setUser,
  //   user?.identity_id,
  // ]);

  const [isFetchingUser, setIsFetchingUser] = useState(true);
  useEffect(() => {
    // Wait for keycloak to be initialized
    if (!keycloak) return;

    // If not authenticated, stop loading and show landing page
    if (!keycloak.authenticated) {
      setIsFetchingUser(false);
      return;
    }

    // If authenticated but no identity_id yet, keep loading
    if (keycloak.authenticated && !user?.identity_id) {
      setIsFetchingUser(true);
      return;
    }

    // If authenticated and identity_id is available, start authorization
    if (keycloak.authenticated && user?.identity_id) {
      const authorizeUser = async () => {
        setIsFetchingUser(true);
        try {
          await fetchUserRoleByIdentity(user.identity_id);
          navigate('/drive', { replace: true });
        } catch (error) {
          navigate('/sign_up', { replace: true });
        }
      };
      authorizeUser();
    }
  }, [keycloak, user?.identity_id, fetchUserRoleByIdentity, navigate]);

  if (!keycloak || isFetchingUser)
    return (
      <div className={styles['loading-container']}>
        <CircularProgress isIndeterminate size="50px" thickness={10} />
      </div>
    );

  /* 
    After authenticate and validate user's existence in database, there will be a flash of landing page before navigate to drive page.
    The line here is to prevent the flash happens.
  */
  if (appUser) return null;

  return (
    <div className={styles['landing-container']}>
      <div className={styles['landing-content']}>
        <div className={styles['copy-container']}>
          <h1 className={styles['landing-title']}>
            Unlock Lidar Visualization
          </h1>
          <p className={styles['landing-paragraph']}>
            Securely and effortlessly store, visualize, manage and share lidar
            data with Ouster Studio
          </p>
        </div>

        <div style={{ display: 'flex', gap: '1rem' }}>
          <Link
            to="/sign_up"
            className={`${styles['primary-button']} ${styles['get-start-button']}`}
            data-testid="get-started-link"
          >
            Get Started <RxArrowRight size={18} />
          </Link>
          <Link
            to="/public"
            className={`${styles['secondary-button']} ${styles['get-start-button']}`}
            data-testid="explore-samples-link"
          >
            Explore Samples <MdOutline3dRotation size={24} />
          </Link>
        </div>
      </div>
    </div>
  );
}
